import * as React from "react";

export default class LazyLoadModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Component: null
    };
  }

  async componentDidMount() {
    const { resolve } = this.props;
    const { default: Component } = await resolve();
    this.setState({ Component });
  }

  render() {
    const { Component } = this.state;
    const { resolve, ...props } = this.props;

    if (!Component) return <div></div>;
    if (Component.view) return React.createElement(Component.view);
    if (Component) return <Component {...props}/>
  }
}
